import Vue from "vue";
import Router from "vue-router";
// import Home from "../views/Home.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: '/login',
    component: () => import("../views/Login.vue")
  },
  {
    path: '/null',
    name: 'null',
    component: () => import("../views/null.vue") // 首页
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue") // 登录
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/Home.vue") // 首页
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/online",
    name: "online",
    component: () => import("../views/Online.vue") // 在线练习
  },
  {
    path: "/offline",
    name: "offline",
    component: () => import("../views/Offline.vue") // 线下课程
  },
  {
    path: "/offlineDetail",
    name: "offlineDetail",
    component: () => import("../views/OfflineDetail.vue") // 线下课程详情
  },
  {
    path: "/offlineApply",
    name: "offlineApply",
    component: () => import("../views/OfflineApply.vue") // 马上报名
  },
  {
    path: "/manage",
    name: "manage",
    component: () => import("../views/Manage.vue") // 企业后台
  },
  {
    path: "/detailList",
    name: "detailList",
    component: () => import("../views/DetailList.vue") // 课题详情
  },
  {
    path: "/detailPlayer",
    name: "detailPlayer",
    component: () => import("../views/DetailPlayer.vue") // 课题详情列表 播放器
  },
  {
    path: '/coursePlay',     //课程视频播放
    name: 'coursePlay',
    component: () => import("../views/coursePlay/coursePlay.vue")
  },
  {
    path: "/exercise",
    name: "exercise",
    component: () => import("../views/Exercise.vue") // 开始做题
  },
  {
    path: "/viewResult",
    name: "viewResult",
    component: () => import("../views/ViewResult.vue") // 查看结果
  },
  {
    path: "/personal",
    name: "personal",
    component: () => import("../views/Personal.vue") // 个人信息
  },
  {
    path: "/applyMessage",
    name: "applyMessage",
    component: () => import("../views/ApplyMessage.vue") // 考试管理
  },
  {
    path: "/personRecord",
    name: "personRecord",
    component: () => import("../views/PersonRecord.vue") // 培训记录
  },
  {
    path: "/personProve",
    name: "personProve",
    component: () => import("../views/PersonProve.vue") // 培训证明
  },
  {
    path: "/personSetting",
    name: "personSetting",
    component: () => import("../views/PersonSetting.vue") // 安全设置
  },
  {
    path: "/approve",
    name: "approve",
    component: () => import("../views/Approve.vue") // 安全设置
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("../views/Notice.vue") // 通知
  },
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import("../views/Login.vue") // 安全设置
  // },
  {
    path: "/system",
    name: "system",
    component: () => import("../views/System.vue") // 八大员系统
  },
  {
    path: "/systemHome",
    name: "systemHome",
    component: () => import("../views/SystemHome.vue") // 八大员系统
  },
  {
    path: '/examList',     //测试列表
    name: 'examList',
    component: () => import("../views/examList/examList.vue")
  },
  {
    path: '/examDetail',     //测试详情
    name: 'examDetail',
    component: () => import("../views/examDetail/examDetail.vue")
  },
  {
    path: '/practiceResult',     //测试结果
    name: 'practiceResult',
    component: () => import("../views/practiceResult/practiceResult.vue")
  },
  {
    path: '/examRecord',     //测试记录
    name: 'examRecord',
    component: () => import("../views/examRecord/examRecord.vue")
  },
  {
    path: '/practiceList',     //练习列表
    name: 'practiceList',
    component: () => import("../views/practiceList/practiceList.vue")
  },
  {
    path: '/practiceDetail',     //练习详情
    name: 'practiceDetail',
    component: () => import("../views/practiceDetail/practiceDetail.vue")
  },
];


const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

// 判断该路由是否需要登录权限
// router.beforeEach((to, from, next) => {
//   let tokenId = localStorage.getItem("tokenId");
//   if (tokenId) {  // 获取当前的token是否存在
//     console.log(from.path);
//     if (to.path != '/login') {
//       next();
//     } else {
//       next({
//         path: from.path
//       });
//     }
//   } else {
//     if (to.path == '/login') {
//       next()
//     } else {
//       next({
//         path: '/login',
//         // query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
//       })
//     }
//   }
// })

// const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

export default router;
